var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Icon } from '../../../../Icon/Icon';
import { useFormTextStateProps } from '../../../context';
export var AdornmentIcon = function (props) {
    var $isDisabled = useFormTextStateProps({}).$isDisabled;
    return (React.createElement(Icon, __assign({ ariaHidden: true }, props, ($isDisabled ? { fill: 'periwinkle-500' } : {}))));
};
//# sourceMappingURL=AdornmentIcon.js.map